var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTravel = function SvgTravel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.227 20.115 1.228-1.229c.362-.36 1.071-.593 1.575-.515l4.801.734 5.728-6.095 6.305-6.708 4.639-4.936a4.34 4.34 0 0 1 6.132-.19c.013.016.054.055.095.094l.092.096a4.34 4.34 0 0 1-.187 6.132l-4.937 4.639 2.136 14.162c.077.507-.157 1.216-.516 1.577L25.54 29.65c-.362.362-.842.283-1.069-.175l-5.484-11.036-6.095 5.729.736 4.8c.078.506-.155 1.213-.517 1.575l-1.228 1.23c-.361.361-.844.28-1.075-.175l-3.46-6.95L.4 21.189c-.456-.227-.534-.711-.173-1.073Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.525 7.53c-.46-.23-.537-.708-.177-1.071l1.776-1.774c.362-.362 1.07-.594 1.575-.518l10.612 1.6L11 11.737z",
    opacity: 0.5
  })));
};
export default SvgTravel;